module.exports = __webpack_public_path__ + "assets/img/banner5.f1548d7c.png";